import * as React from "react";
import { Button, Title1, Body1, makeStyles, tokens, Spinner } from "@fluentui/react-components";
import { startLogin } from "../services/auth";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "80vh",
    gap: "24px",
    textAlign: "center",
  },
  logo: {
    fontSize: "48px",
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorBrandForeground1,
  },
});

interface Props {
  onSuccess: () => void;
}

const LoginScreen: React.FC<Props> = ({ onSuccess }) => {
  const styles = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleLogin = async () => {
    setLoading(true);
    setError(null);

    try {
      const loginUrl = "https://staging.api.ddsign.ae/addin/login";
      await startLogin(loginUrl);
      onSuccess();
    } catch (err: any) {
      setError(err.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.logo}>DD Sign</div>
      <Title1>Sign in to DD Sign</Title1>
      <Body1>Send documents for signing directly from Word.</Body1>
      {error && <Body1 style={{ color: tokens.colorPaletteRedForeground1 }}>{error}</Body1>}
      <Button appearance="primary" size="large" onClick={handleLogin} disabled={loading}>
        {loading ? <Spinner size="tiny" /> : "Sign In"}
      </Button>
    </div>
  );
};

export default LoginScreen;
